/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';
import { useCollection } from '../contexts/CollectionContext.tsx';
import CollectionSelector from './CollectionSelector.tsx';
import './GlobalCollectionSelector.css';

const GlobalCollectionSelector: React.FC = () => {
  const { 
    userCollections, 
    selectedCollectionIndex, 
    setSelectedCollectionIndex,
    loading,
    getCollectionTitle // NEW: Get the title lookup function
  } = useCollection();

  // Don't show if only one collection or still loading
  if (loading || userCollections.length <= 1) {
    return null;
  }

  return (
    <div className="global-collection-selector-wrapper">
      <CollectionSelector
        collections={userCollections} // Array of handles
        selectedIndex={selectedCollectionIndex}
        onSelectionChange={setSelectedCollectionIndex}
        loading={loading}
        label="Viewing:"
        getCollectionDisplayName={(handle) => getCollectionTitle(handle)} // NEW: Convert handle to title
      />
    </div>
  );
};

export default GlobalCollectionSelector;